import React, { useState } from "react";
import { Box, Container, Heading, Text, VStack, HStack, Icon, FormControl, FormLabel, Input, Button, SimpleGrid, Stat, StatLabel, StatNumber, Divider } from "@chakra-ui/react";
import { FaPercentage } from "react-icons/fa";
import { NavbarWithCallToAction } from "../../../components/chakra/NavbarWithCallToAction/NavbarWithCallToAction";
import { FooterWithFourColumns } from "../../../components/chakra/FooterWithFourColumns/FooterWithFourColumns";
import { SEOHead } from "../../../components/SEOHead";

const PROPERTY_PRIMARY = "#0D7F6E";
const NAVY = "#141C49";

const PropertyToolsRentalYield: React.FC = () => {
  const [price, setPrice] = useState(600000);
  const [rent, setRent] = useState(550);
  const [expenses, setExpenses] = useState(8000);

  const grossYield = ((rent * 52) / price) * 100;
  const netYield = (((rent * 52) - expenses) / price) * 100;

  return (
    <Box minH="100vh" bg="white">
      <SEOHead pagePath="/property/tools/rental-yield" fallbackTitle="Rental Yield Calculator" fallbackDescription="Calculate rental yields and investment returns" />
      <NavbarWithCallToAction />
      <Box bgGradient={`linear(to-r, ${NAVY}, ${PROPERTY_PRIMARY})`} color="white" py={20}>
        <Container maxW="container.xl"><VStack spacing={6} textAlign="center"><Icon as={FaPercentage} boxSize={16} /><Heading size="3xl" fontWeight="black">Rental Yield Calculator</Heading><Text fontSize="xl">Calculate gross and net rental yields</Text></VStack></Container>
      </Box>
      <Container maxW="container.xl" py={16}>
        <SimpleGrid columns={{ base: 1, lg: 2 }} spacing={12}>
          <VStack spacing={6} align="stretch">
            <Heading size="lg" color={NAVY}>Property Inputs</Heading>
            <FormControl><FormLabel>Property Value</FormLabel><Input type="number" value={price} onChange={(e) => setPrice(Number(e.target.value))} /></FormControl>
            <FormControl><FormLabel>Weekly Rent</FormLabel><Input type="number" value={rent} onChange={(e) => setRent(Number(e.target.value))} /></FormControl>
            <FormControl><FormLabel>Annual Expenses</FormLabel><Input type="number" value={expenses} onChange={(e) => setExpenses(Number(e.target.value))} /></FormControl>
            <Button bg={PROPERTY_PRIMARY} color="white" _hover={{ bg: "#0a6459" }} size="lg" transition="all 0.2s">Calculate Yield</Button>
          </VStack>
          <VStack spacing={6} align="stretch">
            <Heading size="lg" color={NAVY}>Yield Results</Heading>
            <Stat bg="#EEF0F7" p={6} borderRadius="lg"><StatLabel>Gross Rental Yield</StatLabel><StatNumber fontSize="3xl" color={NAVY}>{grossYield.toFixed(2)}%</StatNumber></Stat>
            <Stat bg="#E1F0EC" p={6} borderRadius="lg"><StatLabel>Net Rental Yield</StatLabel><StatNumber fontSize="3xl" color={PROPERTY_PRIMARY}>{netYield.toFixed(2)}%</StatNumber></Stat>
            <Box bg="gray.50" p={6} borderRadius="lg">
              <Heading size="sm" mb={4} color={NAVY}>Annual Breakdown</Heading>
              <VStack align="stretch" spacing={3}>
                <HStack justify="space-between"><Text fontSize="sm">Rental Income</Text><Text fontWeight="bold">${(rent * 52).toLocaleString()}</Text></HStack>
                <HStack justify="space-between"><Text fontSize="sm" color="red.600">Annual Expenses</Text><Text fontWeight="bold" color="red.600">-${expenses.toLocaleString()}</Text></HStack>
                <Divider />
                <HStack justify="space-between"><Text fontWeight="bold">Net Income</Text><Text fontWeight="bold" color="green.600">${((rent * 52) - expenses).toLocaleString()}</Text></HStack>
              </VStack>
            </Box>
          </VStack>
        </SimpleGrid>
      </Container>
      <FooterWithFourColumns />
    </Box>
  );
};

export default PropertyToolsRentalYield;
